exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.horizontal[data-v-0ed04a21] {\n  width: 1.5rem;\n  height: 0.05rem;\n  background-color: #141414;\n}", ""]);

// exports
